import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { SuiteCTA } from '../../../../features/purchaseMotions/components/SuiteCTA';
import { TalkToSalesFallback } from '../../../../features/purchaseMotions/components/TalkToSalesFallback';
import useSuitePurchaseMotions from '../../../../features/purchaseMotions/hooks/useSuitePurchaseMotions';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { useFTS0011ExperimentAndLogExposure } from '../../../../utils/experiments/fts0011';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import ErrorBoundary from '../../../error-boundary/ErrorBoundary';
import { useCrmSuiteBundleSkuId } from '../../price-display/useCrmSuitePricingInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SuiteCardCTAs = ({
  productLevel,
  screen,
  trackingSource,
  returnFirstCTAOnly = false
}) => {
  const isAppReady = useGlobalLoading();
  const purchaseMotions = useSuitePurchaseMotions({
    productLevel,
    returnFirstCTAOnly
  });
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const {
    isFTS0011Variant
  } = useFTS0011ExperimentAndLogExposure();
  const suiteSkuId = useCrmSuiteBundleSkuId({
    productLevel
  });
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady,
    heights: [47],
    widths: ['100%'],
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      fallback: suiteSkuId ? /*#__PURE__*/_jsx(TalkToSalesFallback, {
        skuId: suiteSkuId,
        screen: screen,
        trackingSource: trackingSource
      }) : null,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        gap: "200",
        inlineSize: "100%",
        children: [purchaseMotions.map((purchaseMotion, index) => {
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteCTA, Object.assign({
              use: index === 0 ? 'primary' : 'secondary',
              purchaseMotion: purchaseMotion,
              productLevel: productLevel,
              trackingSource: trackingSource,
              screen: screen,
              purchaseMotionLocation: "MERCH_CARD"
            }, ctaVariantProps))
          }, purchaseMotion);
        }), isFTS0011Variant && productLevel === 'STARTER' && /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "merchCards.starterCustomerPlatformUpsellCard.noCreditCardRequired"
          })
        })]
      })
    })
  });
};